import { createRoot } from 'react-dom/client'
import * as React from 'react'
import './assets/css/style.css'
import App from './App.tsx'

createRoot(document.getElementById('root')).render(<App />)